import React from 'react';
import { motion } from 'framer-motion';

const ExperienceFilter = ({ categories, activeFilter, onFilter }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
      className="flex flex-wrap gap-2 mb-8 justify-center"
    >
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onFilter(category)}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 capitalize ${
            activeFilter === category
              ? 'bg-primary-500 text-white shadow-lg shadow-primary-500/30'
              : 'bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white'
          }`}
        >
          {category}
        </button>
      ))}
    </motion.div>
  );
};

export default ExperienceFilter;